import { downloadData } from 'aws-amplify/storage';

/** Loads PDF bytes via Amplify (avoids S3 CORS / Content-Disposition download in iframes). */
export async function createInlinePdfObjectUrl(contentPath: string): Promise<string | null> {
    try {
        const { body } = await downloadData({ path: contentPath }).result;
        const blob = await body.blob();
        const pdfBlob =
            blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
        return URL.createObjectURL(pdfBlob);
    } catch (error) {
        console.error('Failed to load PDF for inline viewing', error);
        return null;
    }
}

export function revokeInlinePdfObjectUrl(objectUrl: string | null | undefined): void {
    if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
    }
}
